import actions from './actionTypes';
import {LOAD, INITING, INITD} from '../constants/app';

const defaultState = 0;

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.LOG_IN:
    case actions.LOG_OUT:
    case actions.READ_TOKEN:
      return LOAD;
    case actions.GET_ORGS:
      return INITING;
    case actions.SET_SITES:
      return INITD;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/initd.js